import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from './Footer';
import Nav from './Nav';

function Subprocessors() {
  return (
    <>
      <Nav />
      <Helmet>
        <title>Subprocessors | Speak Your Menu</title>
        <meta name="description" content="List of subprocessors engaged by Speak Your Menu to process data on behalf of our customers." />
        <link rel="canonical" href="https://speakyourmenu.com/subprocessors" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://speakyourmenu.com/" },
            { "@type": "ListItem", position: 2, name: "Subprocessors", item: "https://speakyourmenu.com/subprocessors" },
          ],
        })}</script>
      </Helmet>
      <main id="main-content" tabIndex="-1" className="container my-5">
        <h1 className="mb-4">Speak Your Menu Sub-processor List</h1>
        <p className="text-muted">Last Updated: July 15, 2025</p>

        {/* 1. Overview */}
        <section>
          <h2>1. Overview</h2>
          <p>
            We engage the following subprocessors to help provide and improve our Services. We require all subprocessors to implement appropriate technical and organizational measures to protect your data.
          </p>
        </section>

        {/* 2. Sub-processor List */}
        <section>
          <h2>2. Sub-processor List</h2>
          <p>
            Speak Your Menu uses the third-party service providers listed below to process Personal Data on our behalf. Each Sub-processor is bound by written data-protection terms that offer safeguards equal to or greater than those in our Data Processing Addendum (DPA). We will update this list at least 10 days before we add or replace a Sub-processor.
          </p>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Sub-processor</th>
                <th>Purpose</th>
                <th>Location</th>
                <th>Key Safeguards</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Amazon Web Services (AWS)</td>
                <td>Application hosting (EC2) and encrypted backups (S3)</td>
                <td>USA (us-east-1)</td>
                <td>ISO 27001, SOC 2 Type II, AES-256 storage encryption</td>
              </tr>
              <tr>
                <td>MongoDB Atlas</td>
                <td>Managed database clusters</td>
                <td>USA (us-east-1)</td>
                <td>SOC 2 Type II, TLS 1.2+, disk encryption</td>
              </tr>
              <tr>
                <td>Stripe</td>
                <td>Subscription billing &amp; payment processing</td>
                <td>USA</td>
                <td>PCI-DSS Level 1, TLS 1.2+</td>
              </tr>
              <tr>
                <td>Google (Gmail SMTP)</td>
                <td>Transactional / onboarding e-mail delivery (via NodeMailer)</td>
                <td>USA</td>
                <td>Google security &amp; privacy program, TLS 1.2+</td>
              </tr>
              <tr>
                <td>MailerLite</td>
                <td>Marketing e-mail campaigns</td>
                <td>EU / USA</td>
                <td>GDPR-compliant, TLS 1.2+</td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>How we evaluate Sub-processors</strong><br />
            Every vendor undergoes security and privacy due-diligence, including review of audit reports (e.g., SOC 2), encryption standards, and incident-response procedures.
          </p>
          <p>
            <strong>Objection procedure</strong><br />
            If you have a reasonable privacy objection to any new Sub-processor, e-mail <a href="mailto:support@speakyourmenu.com">support@speakyourmenu.com</a> within 10 days of receiving notice. We’ll work in good faith to address your concerns or propose an alternative solution.
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Subprocessors;
